import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { UtilService } from '../shared/_services/util.service';
@Component({
  selector: 'app-sales-invoice',
  templateUrl: './sales-invoice.component.html',
  styleUrls: ['./sales-invoice.component.scss']
})
export class SalesInvoiceComponent implements OnInit {
  salesInvoiceList: any;
  totalRecords: number;
  defaultPageSize: number = 10;
  page: number = 1;
  pageNos: number;
  public loading = false;
  constructor(private router: Router, private http: AuthService, private util: UtilService) { }
  ngOnInit() {
    this.getSalesInvoiceData(this.page, this.defaultPageSize);
  }
  // To get Sales Invoice Report data
  //@@ pageNumer i.e selected page number
  //@@ pageSize  i.e No of results per page
  getSalesInvoiceData(pageNumer, pageSize) {
    this.loading = true;
    this.page = pageNumer ? pageNumer : this.page;
    this.http.getSalesInvoiceApi(this.page, pageSize).subscribe(res => {
      this.loading = false;
      this.salesInvoiceList = res.responseObj.salesInvoiceReport && res.responseObj.salesInvoiceReport.length ? res.responseObj.salesInvoiceReport : [];
      this.totalRecords = res.responseObj.count ? res.responseObj.count : 0;
    },
      error => {
        this.loading = false;
      });
  }
  // To get date formate date(YYY-MM-DD)
  formatDate(strDate) {
    let dateStr: string = "N/A";
    if (strDate != null) {
      dateStr = this.util.formatDate(strDate);
    }
    return dateStr;
  }
}



// WEBPACK FOOTER //
// ./src/app/sales-invoice/sales-invoice.component.ts